import { createSlice } from '@reduxjs/toolkit';

interface ScoreState {
  scoreCheckVersion: number;
}

const initialState: ScoreState = {
  scoreCheckVersion: 0,
};

const scoreSlice = createSlice({
  name: 'score',
  initialState,
  reducers: {
    bumpScoreCheckVersion(state) {
      state.scoreCheckVersion += 1;
    },
  },
});

export const { bumpScoreCheckVersion } = scoreSlice.actions;
export default scoreSlice.reducer;
